module.exports = __webpack_public_path__ + "img/info.dad1271a.svg";